import { render, staticRenderFns } from "./DtAtrasoAtendimento.vue?vue&type=template&id=19ff39ec"
import script from "./DtAtrasoAtendimento.vue?vue&type=script&lang=js"
export * from "./DtAtrasoAtendimento.vue?vue&type=script&lang=js"
import style0 from "./DtAtrasoAtendimento.vue?vue&type=style&index=0&id=19ff39ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports